import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-redo",
  templateUrl: "./med-icon-redo.component.html",
})
export class MedIconRedoComponent extends SvgMixinComponent {}
